"use client"

import { FC, useCallback, useState } from "react"
import { ChevronDown } from "lucide-react"
import { useContent } from "@/src/context/ContentContext"

const FAQ: FC = () => {
  const { faq } = useContent()
  const [activeFAQ, setActiveFAQ] = useState<number | null>(null)

  const toggleFAQ = useCallback((id: number) => {
    setActiveFAQ((prev) => (prev === id ? null : id))
  }, [])

  return (
    <section
      id="faq"
      className="py-8 lg:py-16 bg-gradient-to-b from-[#1e2126] via-[#181b20] to-[#111216]"
    >
      <div className="container mx-auto">
        <h2 className="text-3xl lg:text-4xl text-white mb-12 text-center font-semibold">
          {faq.sectionTitle}
        </h2>
        <div className="w-full space-y-4">
          {faq.items.map((item) => {
            const isActive = activeFAQ === item.id
            return (
              <div
                key={item.id}
                className="bg-[#1c1c1c] border border-[#2e2e2e] rounded-xl overflow-hidden transition-all"
              >
                <button
                  onClick={() => toggleFAQ(item.id)}
                  className="w-full text-left p-6 bg-[#262a2f] hover:bg-[#2e3238] transition-colors duration-200 flex items-center justify-between"
                >
                  <h3 className="text-lg lg:text-xl font-medium text-white pr-4">
                    {item.question}
                  </h3>
                  <ChevronDown
                    className={`w-6 h-6 text-white flex-shrink-0 transition-transform duration-300 ${
                      isActive ? "rotate-180" : ""
                    }`}
                  />
                </button>
                <div
                  className={`grid transition-[grid-template-rows] duration-300 ease-in-out ${
                    isActive ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
                  }`}
                >
                  <div className="overflow-hidden">
                    <div className="p-6 bg-[#0d0e10] border-t border-gray-800">
                      <p className="text-gray-300 leading-relaxed font-light">{item.answer}</p>
                    </div>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default FAQ
